import "@/App.css";
import Navbar from "@/components/pwt/Navbar";
import Hero from "@/components/pwt/Hero";
import About from "@/components/pwt/About";
import Services from "@/components/pwt/Services";
import MissionVision from "@/components/pwt/MissionVision";
import Ecosystem from "@/components/pwt/Ecosystem";
import Partners from "@/components/pwt/Partners";
import Applications from "@/components/pwt/Applications";
import Contact from "@/components/pwt/Contact";
import Footer from "@/components/pwt/Footer";

export default function App() {
  return (
    <div className="App" data-testid="pwt-app-root">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <MissionVision />
        <Ecosystem />
        <Partners />
        <Applications />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
